import { render } from "./full-screen-modal.vue?vue&type=template&id=28ef8d24&scoped=true"
import script from "./full-screen-modal.vue?vue&type=script&lang=js"
export * from "./full-screen-modal.vue?vue&type=script&lang=js"

import "./full-screen-modal.vue?vue&type=style&index=0&id=28ef8d24&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-28ef8d24"

export default script